export const toTtfbMetric = ({ value, attribution: { connectionDuration, dnsDuration, requestDuration, waitingDuration, }, }) => {
    return {
        ttfb: Math.trunc(value),
        ttfbConnectionDuration: Math.trunc(connectionDuration),
        ttfbDnsDuration: Math.trunc(dnsDuration),
        ttfbRequestDuration: Math.trunc(requestDuration),
        ttfbWaitingDuration: Math.trunc(waitingDuration),
    };
};
//# sourceMappingURL=ttfb.js.map